import { GameManager } from "../GameManager";
import { AudioManager } from "../AudioManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        this.loadHowl();
    }
    
    private composeScene(): void {

        this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "bg_2");

        const loadingLabel = this.add.text(4, GameConstants.GAME_HEIGHT - 15, GameVars.language === GameConstants.ENGLISH ? " LOADING..." : " LADEN...", {fontFamily: "HelveticaNeue", fontSize: "40px", color: "#FFFFFF"});
        loadingLabel.setOrigin(0, 1);

        this.progressBar = this.add.graphics();
        this.progressBar.fillStyle(0xFFFFFF);
        this.progressBar.fillRect(0, GameConstants.GAME_HEIGHT - 10, GameConstants.GAME_WIDTH, 10);
        this.progressBar.scaleX = 0;
    }

    private loadAssets(): void {
        
        this.load.image("bg_1", "assets/bg_01.png");

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2", "assets/texture_atlas_2.png", "assets/texture_atlas_2.json");
        this.load.atlas("texture_atlas_language", "assets/texture_atlas_" + GameVars.language + ".png", "assets/texture_atlas_" + GameVars.language + ".json");
       
        this.load.json("sound", "assets/audio/sound.json");
        this.load.json("music", "assets/audio/music.json");

        this.load.json("game-text", "assets/text/game-text.json");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        if (this.progressBar.scaleX < percentageLoaded) {
            this.progressBar.scaleX = percentageLoaded;
        }
    }

    private loadHowl(): void {

        let json = this.cache.json.get("sound");
        json = JSON.parse(JSON.stringify(json).replace("urls", "src"));

        AudioManager.sound = new Howl(json);

        AudioManager.sound.on("load", function(): void {

            let json2 = PreloadScene.currentInstance.cache.json.get("music");
            json2 = JSON.parse(JSON.stringify(json2).replace("urls", "src"));

            AudioManager.music = new Howl(json2);

            AudioManager.music.on("load", function(): void {

                GameManager.onGameAssetsLoaded();
            });
        });
    }
}
